import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUser = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.5 7.75C8.5 5.95507 9.95507 4.5 11.75 4.5C13.5449 4.5 15 5.95507 15 7.75C15 9.54493 13.5449 11 11.75 11C9.95507 11 8.5 9.54493 8.5 7.75ZM11.75 3C9.12665 3 7 5.12665 7 7.75C7 10.3734 9.12665 12.5 11.75 12.5C14.3734 12.5 16.5 10.3734 16.5 7.75C16.5 5.12665 14.3734 3 11.75 3ZM8 15C5.23858 15 3 17.2386 3 20V20.75C3 21.1642 3.33579 21.5 3.75 21.5C4.16421 21.5 4.5 21.1642 4.5 20.75V20C4.5 18.067 6.067 16.5 8 16.5H15.5C17.433 16.5 19 18.067 19 20V20.75C19 21.1642 19.3358 21.5 19.75 21.5C20.1642 21.5 20.5 21.1642 20.5 20.75V20C20.5 17.2386 18.2614 15 15.5 15H8Z",
		fill: "currentColor"
	})
});
export default SvgUser;
